<template>
  <div class="content subscriptions_sec">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <nav aria-label="breadcrumb" role="navigation" class="m-0">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: defaultScreen }"> Home</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Subscriptions
            </li>
          </ol>
        </nav>
        <div class="navbar md-toolbar md-transparent md-elevation-4">
          <h1 class="section_header my-2">Subscriptions</h1>
          <!-- <div class="md-toolbar-row">
            <div class="md-toolbar-section-start">
              <h1 class="md-title">
                Subscriptions
              </h1>
            </div>
          </div> -->
        </div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 subscription_wpr">
        <!-- <nav-tabs-card no-label md-elevation="0">
          <template slot="content">
            <md-tabs md-alignment="left">
              <products-accessed-tab />
              <renew-upgrade-tab />
              <account-activity-tab />
              <manage-team-tab />
            </md-tabs>
          </template>
        </nav-tabs-card> -->
        <div class="md-layout">
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <products-accessed-tab />
          </div>
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <renew-upgrade-tab />
          </div>
          <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <account-activity-tab />
          </div>
          <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
            <manage-team-tab />
          </div> -->
        </div>
      </div>
    </div>

    <!-- <products-accessed />
    <renew-upgrade id="renew-upgrade" />
    <account-activity />
    <manage-team /> -->

    <modal v-if="$store.getters['showNewTeamModal']" @close="closeNewTeamModal()">
      <template slot="header">
        <h4 class="modal-title">Add New Team Member</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeNewTeamModal()">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="field-wrap">
          <md-field>
            <label>Email*</label>
            <md-input type="email" v-model="newMemberData.email"></md-input>
          </md-field>
          <md-field>
            <label>First Name*</label>
            <md-input type="text" v-model="newMemberData.firstName"></md-input>
          </md-field>
          <md-field>
            <label>Last Name*</label>
            <md-input type="text" v-model="newMemberData.lastName"></md-input>
          </md-field>
          <md-field>
            <label>Credits</label>
            <md-input type="text" v-model="newMemberData.reportLimit"></md-input>
          </md-field>
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-info md-round mb-4 md-theme-default" @click="addNewTeamMember()">Add</md-button>
        <md-button class="md-info md-round mb-4 md-danger md-simple" @click="closeNewTeamModal()">Close</md-button>
      </template>
    </modal>

    <modal v-if="$store.getters['showUpdateTeamModal']" @close="closeUpdateTeamModal()">
      <template slot="header">
        <h4 class="modal-title">Update Team Member</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeUpdateTeamModal()">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <div class="field-wrap">
          <md-field>
            <label>Email*</label>
            <md-input type="email" v-model="updateMemberData.email"></md-input>
          </md-field>
          <md-field>
            <label>First Name*</label>
            <md-input type="text" v-model="updateMemberData.firstName"></md-input>
          </md-field>
          <md-field>
            <label>Last Name*</label>
            <md-input type="text" v-model="updateMemberData.lastName"></md-input>
          </md-field>
          <md-field>
            <label>Credits</label>
            <md-input type="text" v-model="updateMemberData.limit"></md-input>
          </md-field>
        </div>
      </template>

      <template slot="footer">
        <md-button class="md-info md-round mb-4 md-theme-default" @click="updateNewTeamMember()">Update</md-button>
        <md-button class="md-info md-round mb-4 md-danger md-simple" @click="closeUpdateTeamModal()">Close</md-button>
      </template>
    </modal>
  </div>
</template>

<script>
import ProductsAccessedTab from './_partials/ProductsAccessedTab';
import RenewUpgradeTab from './_partials/RenewUpgradeTab';
import AccountActivityTab from './_partials/AccountActivityTab';
import ManageTeamTab from './_partials/ManageTeamTab';
import { NavTabsCard, Modal } from '@/components';
import axios from 'axios';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'subscriptions',
  components: {
    ProductsAccessedTab,
    RenewUpgradeTab,
    // AccountActivityTab,
    // ManageTeamTab,
    // NavTabsCard,
    Modal,
  },
  data() {
    return {
      newMemberData: {},
      updateMemberData: {},
    };
  },
  async created() {
    await this.getSubscriptionsInfo();
  },
  computed: {
    ...mapState({
      auth_user: (state) => state.user,
      defaultScreen: (state) => state?.user?.user?.preferences?.defaultScreen,
    }),
    ...mapGetters(['updateTeamMemberDetails']),
  },
  watch: {
    updateTeamMemberDetails() {
      let details = this.$store.getters['updateTeamMemberDetails'];

      if (details) {
        this.updateMemberData.email = details.email;
        this.updateMemberData.firstName = details.firstName;
        this.updateMemberData.lastName = details.lastName;
        this.updateMemberData.member_id = details.id;
        this.updateMemberData.reportLimit = details.limit?details.limit:null;
      }
    },
  },
  methods: {
    async getSubscriptionsInfo() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      await axios
        .post(
          process.env.VUE_APP_API_BASE_URL + '/user/subscriptions/info',
          {},
          {
            params: {
              session_id: currentSession,
              profile_id: this.id,
            },
          }
        )
        .then((res) => {
          if (res.hasOwnProperty('data') && res.data.error) {
            this.$store.commit('SET_ERROR_BIT', true);
            this.$store.commit(
              'SET_ERROR_INFO',
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/subscriptions/info" <br>`
            );
            throw new Error(
              '<br>' +
                'Server responded with error = True <br> errorCode: ' +
                res.data.errorCode
            );
          }
          this.$store.commit('SET_SUBSCRIPTIONS_INFO', res.data);
        });
    },
    closeNewTeamModal() {
      this.$store.commit('SET_SHOW_NEW_TEAM_MODAL', false);
    },
    updateNewTeamModal() {
      this.$store.commit('SET_SHOW_NEW_TEAM_MODAL', false);
    },
    closeUpdateTeamModal() {
      this.$store.commit('SET_SHOW_UPDATE_TEAM_MODAL', false);
    },
    async addNewTeamMember() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );
      if(this.newMemberData.limit = '')
        this.newMemberData.limit = null;

      let params = this.newMemberData;
      params.username = '';
      params.session_id = currentSession;

      await this.$store.dispatch('team/add', params).then((res) => {
        this.$store.dispatch(
          'alerts/success',
          'Team member added.'
        );
        this.closeNewTeamModal();
        this.$store.commit('SET_UPDATE_TEAM_MEMBER_DETAILS', {});
      });
    },
    async updateNewTeamMember() {
      let currentSession = localStorage.getItem(
        'vue-authenticate.vueauth_access_token'
      );

      let params = this.updateMemberData;
      params.session_id = currentSession;

      await this.$store.dispatch('team/edit', params).then((res) => {
        this.$store.dispatch(
          'alerts/success',
          'Team member updated.'
        );
        this.closeUpdateTeamModal();
        this.$store.commit('SET_UPDATE_TEAM_MEMBER_DETAILS', {});
      });
    },
  },
};
</script>
